module.exports = "\n/**\n * That text on the left doesn't really look good. Let's edit it a little bit.\n */\n\n#work-text.flipped {\n  -webkit-transform: transformX(98.5%) rotateX(0deg) rotateY(170deg);\n}\n\n#work-text .md {\n  -webkit-transform: rotateY(170deg) transformX(98.5%);\n}\n\n/**\n * Alright, now we're ready.\n *\n * 3...\n * 2...\n * 1...\n *\n * .\n * ....gotcha!\n *\n * Okay here we go!\n *\n */\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./styles1.css
 ** module id = 84
 ** module chunks = 0 1
 **/